import React from "react";


export default function FaqGeneratorStep({ lang }) {

  return (
        <div className="mb-5">
          <h2 className="text-center mb-4">{lang[10]}</h2>
          <div className="accordion">
            <div className="accordion-item border-0 mb-4 px-lg-5 px-4 rounded">
              <h2 className="accordion-header">
                <button className="accordion-button text-dark px-0 py-lg-5 py-4 fs-3 fw-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true"
                        aria-controls="panelsStayOpen-collapseOne">
                  {lang[0]}
                </button>
              </h2>
              <div id="panelsStayOpen-collapseOne" className="accordion-collapse collapse show">
                <div className="accordion-body text-dark px-0 border-top py-4">
                  {lang[1]}
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 mb-4 px-lg-5 px-4 rounded">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed text-dark px-0 py-lg-5 py-4 fs-3 fw-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseTwo">
                  {lang[2]}
                </button>
              </h2>
              <div id="panelsStayOpen-collapseTwo" className="accordion-collapse collapse">
                <div className="accordion-body text-dark px-0 border-top py-4">
                  {lang[3]}
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 mb-4 px-lg-5 px-4 rounded">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed text-dark px-0 py-lg-5 py-4 fs-3 fw-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapseThree">
                  {lang[4]}
                </button>
              </h2>
              <div id="panelsStayOpen-collapseThree" className="accordion-collapse collapse">
                <div className="accordion-body text-dark px-0 border-top py-4">
                  {lang[5]}
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 mb-4 px-lg-5 px-4 rounded">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed text-dark px-0 py-lg-5 py-4 fs-3 fw-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapse4" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapse4">
                  {lang[6]}
                </button>
              </h2>
              <div id="panelsStayOpen-collapse4" className="accordion-collapse collapse">
                <div className="accordion-body text-dark px-0 border-top py-4">
                  {lang[7]}
                </div>
              </div>
            </div>
            <div className="accordion-item border-0 mb-4 px-lg-5 px-4 rounded">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed text-dark px-0 py-lg-5 py-4 fs-3 fw-bold" type="button"
                        data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapse5" aria-expanded="false"
                        aria-controls="panelsStayOpen-collapse5">
                  {lang[8]}
                </button>
              </h2>
              <div id="panelsStayOpen-collapse5" className="accordion-collapse collapse">
                <div className="accordion-body text-dark px-0 border-top py-4">
                  {lang[9]}
                </div>
              </div>
            </div>
          </div>
        </div>
  )
}